import { NewLicenseFormData } from '@/interfaces/license.interface';
import type { Product } from "@/interfaces/product.interface"; 

// Generate unique UUID
export const generateUniqueUID = () => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};

export const defaultGrades = () => [
  ...Array.from({ length: 12 }, (_, index) => {
    const gradeLevel = index + 1;
    const editing: Record<string, any> = { maths: false, english: false };

    return {
      grade: gradeLevel.toString(),
      selected: false,
      classes: [
        {
          tempId: generateUniqueUID(),
          name: '',
          teacher: '',
          subject: '',
          gradeLevel,
          preferredLanguage: '',
          english: false,
          maths: false,
          englishTeachers: {},
          mathsTeachers: {},
        },
      ],
      editing,
    };
  }),
];

export const createDefaultSchoolLicenseObject = (
  schoolGroupId: string,
  products: Product[]
) => ({
  name: "",
  domain: "",
  emisNumber: "",
  schoolGroup: schoolGroupId,
  academicYearStart: "",
  academicYearEnd: "",
  preferredLang: "",
  location: {
    city: "",
    country: "",
    street: "",
  },
  schoolLicenseData: {
    type: "annual",
    startDate: "",
    endDate: "",
    products: products.map((product) => ({
      product: product._id,
      maxSeats: 0,
      seatsUsed: 0,
    })),
  } as NewLicenseFormData,
});

export const createDefaultNewAdmin = (schoolId: string) => ({
  firstName: "",
  lastName: "",
  email: "",
  designation: "School Champion",
  status: "inactive",
  roles: [],
  phoneNumber: null,
  school: schoolId,
});

export const createDefaultSchoolObject = () => ({
  _id: "",
  name: "",
  code: "",
  description: "",
  language: "",
  domain: "",
  status: "",
  emisNumber: "",
  isPartOfGroup: false,
  schoolGroup: "",
  academicYearStart: "",
  academicYearEnd: "",
  preferredLang: "",
  location: {
    city: "",
    country: "",
    street: "",
  },
});

export const defaultNewSchoolGroupAdmin = {
  firstName: "",
  lastName: "",
  email: "",
  designation: "School Group Champion",
  status: "inactive",
  roles: [],
  phoneNumber: null,
  schoolGroup: ""
};
  
export const defaultSchoolGroup = {
  name: "",
  description: ""
};
